import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from '@material-ui/core';
import { CheckCircle, Close } from '@material-ui/icons';
import { Color, ColorDynamic, Column, Columns, Stack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { openExternalURL } from 'shared/helpers/URLHelpers';
import { ArrowRightCircledIcon } from 'shared/icons';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  background: ${ColorDynamic.White};
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;

  padding-top: 128px;
  padding-bottom: 128px;
  margin: -16px;
`;

const Video = styled.video`
  width: 460px;
  height: auto;
  border-radius: 8px;
`;

interface OnboardingChromeExtensionDialogProps {
  open: boolean;
  onClose: () => void;
  onComplete: () => void;
}

export function OnboardingSDConnectionDialog({
  open,
  onClose,
  onComplete,
}: OnboardingChromeExtensionDialogProps) {
  return (
    <Dialog fullWidth={true} maxWidth="lg" open={open} onClose={onClose}>
      <DialogTitle>
        <Columns align="top">
          <Column width="fluid">
            <Typography variant="h3">Add Super Dispatch Connection</Typography>
          </Column>

          <Column width="content">
            <IconButton size="small" aria-label="close">
              <Close />
            </IconButton>
          </Column>
        </Columns>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Container>
          <Box padding="small" paddingTop="none" maxWidth="452px">
            <Stack space="large">
              <Box paddingTop="small">
                <Stack space="medium">
                  <Columns space="small">
                    <Column width="content">
                      <CheckCircle
                        htmlColor={Color.Green300}
                        fontSize="large"
                      />
                    </Column>
                    <Column width="fluid">
                      <Stack>
                        <Typography variant="h3" color="textSecondary">
                          Verification in progress
                        </Typography>
                        <Typography color="textSecondary">
                          Your application has been submitted and is under
                          review. Our team will contact you if additional
                          information is needed. Once your application is
                          approved you can submit load requests.
                        </Typography>
                      </Stack>
                    </Column>
                  </Columns>

                  <Columns space="small">
                    <Column width="content">
                      <ArrowRightCircledIcon color="action" fontSize="large" />
                    </Column>
                    <Column width="fluid">
                      <Stack>
                        <Typography variant="h3">
                          Next, try load import
                        </Typography>
                        <Typography color="textSecondary">
                          Click Import Load or simply drag & drop files in Loads
                          page. We support most of the load boards.
                        </Typography>
                      </Stack>
                    </Column>
                  </Columns>
                </Stack>
              </Box>

              <Box paddingLeft="large">
                <Button
                  variant="text"
                  onClick={() => {
                    onComplete();
                    openExternalURL('/tms/loads');
                  }}
                >
                  Try Load Import
                </Button>
              </Box>
            </Stack>
          </Box>

          <Box maxWidth="460px">
            <Video loop={true} autoPlay={true} muted={true}>
              <source
                src="https://storage.googleapis.com/superdispatch-email-resources/load-import.mp4"
                type="video/mp4"
              />
              <track kind="captions" />
            </Video>
          </Box>
        </Container>
      </DialogContent>
    </Dialog>
  );
}
